module.exports = __webpack_public_path__ + "static/img/tu5@2x.a8e31f18.png";